// extracted by mini-css-extract-plugin
export var bodyRow = "_ch-d";
export var cardColumns = "_ch-e";
export var ellipsesOverflow = "_ch-2";
export var flatBottomCorners = "_ch-3";
export var flatTopCorners = "_ch-4";
export var headerActionsDropdown = "_ch-f";
export var headerBottomRow = "_ch-c";
export var headerTopRow = "_ch-b";
export var orderDetailsWrapper = "_ch-0";
export var orderInfoContainer = "_ch-1";
export var productDetails = "_ch-9";
export var productImage = "_ch-5";
export var responsiveTable = "_ch-8";
export var shipmentContainer = "_ch-a";
export var tableBottomLeft = "_ch-6";
export var tableBottomRight = "_ch-7";
export var trackingLink = "_ch-g";